<template>
  <v-scale-screen width="1920" height="1080">
    <div style="background-color: #000000;height: 1080px">
      <div class="header"
           style="width: 1920px;height: 88px;box-sizing: border-box; display: flex;justify-content: flex-start;text-align: left;">
        <div style="width: 720px;padding-left: 42px; font-size: 44px;font-weight: bold;color: #FFFFFF;">
          吉华衬塑数字车间数据大屏
        </div>
        <div style="width: 1200px; display: flex;justify-content: left;align-items: center;">
          <div class="top-box" @click="clickTopBox(item,index)" v-for="(item,index) in topBoxList" :key="index"
               :class="{'activeBox':item.active}"
               style="cursor: pointer; color: #FFFFFF;font-size: 16px;margin-left: 36px; width: 131.5px;height: 42px;text-align: center;line-height: 34.5px">
            {{ item.project_name }}
          </div>
        </div>
      </div>
      <div style="width: 1920px;display: flex;justify-content: center">
        <div class="main" style="width: 1344px; box-sizing: border-box;margin-top: 40px;padding-left: 20px;">
          <div style="display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap">
            <div class="mainTopBox" :class="{'mainTopBoxActive':item.active}" @click="clickMainTopBox(item,index)"
                 v-for="(item,index) in topMainBoxList" :key="index">
              {{ item.grade_name }}
            </div>
          </div>
          <mianBottom  :topValue="topValue" :dataForm="dataForm"></mianBottom>
        </div>
        <div style="height: 100%;padding:20px;">
          <div class="right-top" style="display: flex;align-items: center">
            <el-select v-model="searchForm.grade_id" placeholder="请选择型号" clearable>
              <el-option
                  v-for="item in topMainBoxList"
                  :key="item.id"
                  :label="item.grade_name"
                  :value="item.id">
              </el-option>
            </el-select>
            <div @click="chaxun"
                 style="line-height: 36px;color: #FFFFFF;margin-left: 12px;cursor: pointer; width: 71px;height: 36px;border-radius: 4px;background: linear-gradient(180deg, #323647 0%, #222631 100%);box-sizing: border-box;border: 1px solid #15D5FE;box-shadow: 0px 0px 4px 0px rgba(24, 254, 254, 0.5);">
              查询
            </div>
          </div>
          <div class="right-list" style="margin-top: 40px;">
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <img src="@/assets/tongji.svg" style="width: 24px;height: 24px;">
              <div style="font-size: 18px;font-weight: bold;color: #FFFFFF;margin-left: 10px">数值变更记录</div>
            </div>
            <div style="margin-top: 25px;width: 100%" v-if="tableData.length!==0">
              <div class="table-top"
                   style="font-size: 16px; color: #FFFFFF; width: 100%; display: flex;justify-content: flex-start;align-items: center">
                <div style="width: 18%">型号</div>
                <div style="width: 18%">更改项</div>
                <div style="width: 18%">原值</div>
                <div style="width: 18%">更改后</div>
                <div style="width: 28%">更改时间</div>
              </div>
            </div>
            <div class="table-content" v-if="tableData.length!==0" v-for="(item,index) in tableData" :key="index"
                 @click="popupStart(item,index)"
                 style="cursor: pointer; padding: 8px;box-sizing: border-box; margin-top: 10px; width: 100%;height: 31px;border-radius: 3px;background: #203C5E;display: flex;justify-content: flex-start;align-items: center">
              <div style="width: 18%; font-size: 14px;color: #FFFFFF;font-weight: 500;">{{ item.grade_name }}</div>
              <div style="width: 18%;font-size: 14px;color: #FFFFFF;font-weight: 500;">{{ item.edit_desc }}</div>
              <div style="width: 18%;font-size: 14px;color: #FFFFFF;font-weight: 500;">{{ item.old }}</div>
              <div style="width: 18%;font-size: 14px;color: #FFFFFF;font-weight: 500;">{{ item.new }}</div>
              <div style="width: 28%;font-size: 14px;color: #FFFFFF;font-weight: 500;">{{ item.edit_time }}</div>
            </div>
            <div class="pageChange"
                 style="margin-top: 26px; display: flex;justify-content: center;align-items: center;"
                 v-if="tableData.length!==0">
              <el-pagination
                  @current-change="currentChange"
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="searchForm.pageSize"
                  :current-page="searchForm.pageNum"
              >
              </el-pagination>
            </div>
            <div v-if="tableData.length===0"
                 style="width: 100%;height:100%;display: flex;justify-content: center;align-items: center;flex-direction: column ">
              <img src="@/assets/zanwuxinxi.png" style="width: 201px;height: 139px;">
              <div style="font-size: 14px;color: #74C5FF;margin-top: 27px">暂无记录</div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 页面具体业务逻辑 -->
    <div>
      <el-dialog :visible.sync="dialogTableVisible" width="1387px" :modal="false">
        <div style="display:flex;align-items: center">
          <div
              style="margin-left: 20px; color: #FFFFFF;font-size: 14px;font-weight: 500;width: 515px;height: 31px;border-radius: 3px;background: #203C5E;display: flex;justify-content: space-around;align-items: center">
            <div>{{ form.grade_name }}</div>
            <div>{{ form.edit_desc }}</div>
            <div>{{ form.old }}</div>
            <div>{{ form.new }}</div>
            <div>{{ form.edit_time }}</div>
          </div>
          <div style="margin-left: 10px;color: #FFFFFF;font-size: 18px;font-weight: 600">调整后数据</div>
        </div>

        <div style="width: 100%;margin-top: 26px;">
          <mianBottom :topValue="topValue" :dataForm="form" :dialogTableVisible="dialogTableVisible"></mianBottom>
        </div>
      </el-dialog>
    </div>


  </v-scale-screen>
</template>

<script>
// @ is an alias to /src
import mianBottom from "@/components/mian-bottom.vue";
import axios from "axios";

export default {
  name: 'HomeView',
  components: {mianBottom},
  data() {
    return {
      selectValue: "",
      dialogTableVisible: false,
      form: {},
      activeIndex: 0,
      activeMainIndex: 0,
      searchForm: {
        pageSize: 16,
        pageNum: 1,
        grade_id: "",
        project_id: 1
      },
      formId:"",
      tableData: [],
      total: 0,
      topBoxList: [],
      topMainBoxList: [],
      topValue: 1,
      dataForm: {},
      nameGo:"",
      statusShow:true
    }
  },
  created() {
    this.init()
    this.times = setInterval(() => {
      this.statusShow = false
      this.initData();
    }, 1000*120);
  },
  destroyed() {
    clearInterval(this.times)
  },
  methods: {
    currentChange(value){
      this.statusShow = false
      this.searchForm.pageNum = value
      this.getList()
    },
    init() {
      // this.getGrade()

      if (localStorage.getItem('token')) {
        this.getProject()

      } else {
        this.$message({
          showClose: true,
          message: '登录过期，请重新登录',
          type:"error"
        });
        this.$router.push('/login')
      }

    },
    initData(){
      this.getDetail(this.formId)
      this.searchForm.pageNum = 1
      this.getList()
    },
    chaxun() {
      this.statusShow = false
      this.searchForm.pageNum = 1
      this.getList("init")
    },
    getList(status) {
      let token = localStorage.getItem("token")

      axios.get("https://plc.yunminet.site/adminapi/edit_log/lists?page_no=" + this.searchForm.pageNum + "&page_size=" + this.searchForm.pageSize + "&grade_id=" + this.searchForm.grade_id + "&project_id=" + this.searchForm.project_id, {
        headers: {
          'token': token
        }
      }).then(res => {

        if (res.data.code === -1) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
          this.$router.push('/login')
        } else if (res.data.code === 1) {
          this.tableData = res.data.data.lists


          if(this.statusShow){
            this.formId = this.tableData[0].grade_id
            this.getDetail(this.formId)
            let topIndex = this.topMainBoxList.findIndex(item=> item.id === this.formId)
            console.log(topIndex)
            this.topMainBoxList[topIndex].active = true
          }

          this.total = res.data.data.count
          console.log(res.data)
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
        }

      })
    },
    // http://plc.yunminet.site/adminapi/edit_log/detail
    getDetail(id) {
      let token = localStorage.getItem("token")
      axios.get("https://plc.yunminet.site/adminapi/edit_log/detail?id=" + id, {
        headers: {
          'token': token
        }
      }).then(res => {

        if (res.data.code === -1) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
          this.$router.push('/login')
        } else if (res.data.code === 1) {
          this.dataForm = res.data.data
          console.log(res.data)
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
        }

      })
    },
    getGrade(id) {
      let token = localStorage.getItem("token")
      axios.get("https://plc.yunminet.site/adminapi/edit_log/getGrade?project_id=" + id, {
        headers: {
          'token': token
        }
      }).then(res => {
        if (res.data.code === -1) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
          this.$router.push('/login')
        } else if (res.data.code === 1) {
          this.topMainBoxList = res.data.data
          if (this.topMainBoxList.length !== 0) {
            this.topMainBoxList.forEach((item1) => {
              item1.active = false
            })
            // this.topMainBoxList[0].active = true
            // this.formId = this.topMainBoxList[0].id
            // this.getDetail(this.topMainBoxList[0].id)

          }
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
        }


      })
    },
    getProject() {
      let token = localStorage.getItem("token")
      axios.get("https://plc.yunminet.site/adminapi/edit_log/getProject", {
        headers: {
          'token': token
        }
      }).then(res => {
        if (res.data.code === -1) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
          this.$router.push('/login')
        } else if (res.data.code === 1) {
          this.topBoxList = res.data.data
          this.topBoxList.forEach((item1) => {
            item1.active = false
          })
          this.topBoxList[0].active = true
          this.getGrade(this.topBoxList[0].id)
          this.topValue = 1
          this.searchForm.project_id = this.topBoxList[0].id
          this.getList()
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type:"error"
          });
        }

      })
    },
    popupStart(item, index) {
      this.dialogTableVisible = true

      this.form = item
      // this.form.change_field.push('a_len')
    },
    clickTopBox(item, index) {
      this.statusShow = true
      this.topBoxList.forEach((item1) => {
        item1.active = false
      })
      this.dataForm = {}
      this.topBoxList[index].active = true
      this.activeIndex = index
      this.getGrade(this.topBoxList[index].id)
      this.searchForm.grade_id = ""
      if(item.project_name==='1号生产线'){
        this.topValue = 1
      }else if(item.project_name==='2号生产线'){
        this.topValue = 2
      }else if(item.project_name==='3号生产线'){
        this.topValue = 3
      }
      // this.topValue = item.id
      this.searchForm.project_id = item.id
      this.searchForm.pageNum = 1
      this.getList()
      this.$forceUpdate()
    },
    clickMainTopBox(item, index) {
      this.topMainBoxList.forEach((item1) => {
        item1.active = false
      })
      this.topMainBoxList[index].active = true
      this.activeMainIndex = index
      this.formId = item.id
      this.getDetail(item.id)
      this.selectValue = ""
      this.$forceUpdate()

    },
  },

}
</script>
<style scoped>
.header {
  background-image: url("@/assets/header-top.png");
  background-size: 100% 100%;
//box-sizing: border-box !important; padding-top: 7px; padding-bottom: 11px;
}

.top {
  height: 10% !important;
}

::v-deep.el-header {
  padding: 0 !important;

}

.top-box {
  background-image: url("@/assets/buttonNoActive.png");
  background-size: cover;
}

.activeBox {
  background-image: url("@/assets/buttonActive.png");
  background-size: cover;
  color: #000000 !important;
}

.mainTopBox {
  background-image: url("@/assets/buttonNoActive.png");
  background-size: cover;
  width: 131.5px;
  height: 41.5px;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  line-height: 34.5px;
  cursor: pointer;
  margin-left: 20px;
}

.mainTopBoxActive {
  background-image: url("@/assets/buttonActive.png");
  background-size: cover;
  color: #000000 !important;
}

.mainContentTopBox {
  width: 416px;
  height: 451px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/mainback.png");
  background-size: cover;
  margin-right: 19px;
}

.mainContentTopBox-box {
  background-color: #213957;
  width: 174px;
  height: 80px;
  background-image: url("@/assets/numberback.png");
  background-size: cover;
}

.secondContent-box {
  width: 416px;
  height: 165.5px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/backcolor.png");
  background-size: cover;
  margin-right: 19px;
}

.secondContent-box-main {
  background-color: #213957;
  width: 174px;
  height: 80px;
  background-image: url("@/assets/numberback.png");
  background-size: cover;
}

.secondContent-box-duan {
  width: 194px;
  height: 168px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/backcolorshort.png");
  background-size: cover;
  margin-right: 19px;
}

.secondContent-box-main-duan {
  background-color: #213957;
  width: 162px;
  height: 80px;
  background-image: url("@/assets/numberback.png");
  background-size: 100% 100%;
}

::v-deep .el-input__prefix {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

::v-deep .el-input__inner {
  width: 200px;
  height: 36px;
//padding-left: 40px !important; border-radius: 4px;
  background: linear-gradient(180deg, #323647 0%, #222631 100%);
  box-sizing: border-box;
  border: 1px solid #15D5FE;
  box-shadow: 0px 0px 4px 0px rgba(24, 254, 254, 0.5);
  color: #FFFFFF !important;
}

.right-list {
  width: 557px;
  height: 835px;
  box-sizing: border-box;
  padding: 12px 28px 28px 28px;
  background-image: url("@/assets/rightback.png");
  background-size: 100% 100%;
  margin-right: 19px;
}

::v-deep .number {
  border-radius: 2px !important;
  box-sizing: border-box !important;
  border: 1px solid #74C5FF !important;
  background-color: black !important;
  color: #74C5FF !important;
  font-weight: normal;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgba(116, 197, 255, 1) !important;
  color: #FFFFFF !important;
  font-weight: normal;
}

::v-deep .btn-prev {
  border-radius: 2px !important;
  box-sizing: border-box !important;
  border: 1px solid #74C5FF !important;
  background-color: black !important;
  color: #74C5FF !important;
  font-weight: normal;
}

::v-deep .btn-quicknext {
  border-radius: 2px !important;
  box-sizing: border-box !important;
  border: 1px solid #74C5FF !important;
  background-color: black !important;
  color: #74C5FF !important;
  font-weight: normal;
}

::v-deep .btn-next {
  border-radius: 2px !important;
  box-sizing: border-box !important;
  border: 1px solid #74C5FF !important;
  background-color: black !important;
  color: #74C5FF !important;
  font-weight: normal;
}

::v-deep .btn-quickprev {
  border-radius: 2px !important;
  box-sizing: border-box !important;
  border: 1px solid #74C5FF !important;
  background-color: black !important;
  color: #74C5FF !important;
  font-weight: normal;
}

::v-deep .el-dialog {
  border-radius: 12px !important;
  background: #001733 !important;
  box-shadow: 0px 0px 20px 0px rgba(116, 197, 255, 0.6) !important;
  margin-top: 30px !important;

}

.v-modal {
  position: relative !important;
}

::v-deep .el-dialog__wrapper {
  z-index: 1000000 !important;
}
</style>
